module.exports = __webpack_public_path__ + "static/media/jmi-logo.f7af61c7.png";